export default "__VITE_ASSET__Cz5ZaQVH__"